export default __webpack_public_path__ + "static/media/indimg7.a9d48114.webp";